import NavBar from "../Components/navbar";

function App(){
    return (
        <body>
            <NavBar/>
        </body>
    );
}
export default App;